function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t.st0{fill:#A43432;}\r\n\t.st1{fill:#231F20;}\r\n");

var _ref3 = /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "3.91,64.89 39.12,64.89 39.12,54.13 16.87,54.13 16.87,38.27 37.56,38.27 37.56,27.59 16.87,27.59  16.87,14.1 39.12,14.1 39.12,3.43 3.91,3.43 "
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M88.3,8.23c-3.85-3.2-9.49-4.81-16.91-4.81H51.86v61.47h12.96V43.03h5.57c7.58,0,13.43-1.77,17.54-5.27 c4.11-3.5,6.17-8.55,6.17-15.17C94.09,16.23,92.17,11.45,88.3,8.23z M78.04,29.97c-1.98,1.58-4.97,2.37-8.95,2.37h-4.27V14.1h5.89 c3.54,0,6.15,0.73,7.81,2.18c1.66,1.46,2.48,3.72,2.48,6.77C81.01,26.09,80.02,28.4,78.04,29.97z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M167.57,78.67c0-1.27-0.39-2.21-1.17-2.84c-0.78-0.63-1.99-0.94-3.62-0.94h-3.66v13.4h1.55v-5.57h2.78 l3.23,5.57h1.83l-3.62-6.02C166.68,81.64,167.57,80.44,167.57,78.67z M162.79,81.37h-2.13v-5.12h2.01c1.15,0,1.99,0.2,2.51,0.59 c0.52,0.39,0.78,1.03,0.78,1.91c0,0.87-0.26,1.53-0.77,1.97C164.69,81.15,163.88,81.37,162.79,81.37z"
});

var _ref6 = /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "148.72,88.28 156.16,88.28 156.16,86.89 150.28,86.89 150.28,81.96 155.8,81.96 155.8,80.58  150.28,80.58 150.28,76.27 156.16,76.27 156.16,74.88 148.72,74.88 "
});

var _ref7 = /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "173.85,76.27 178.07,76.27 178.07,88.28 179.62,88.28 179.62,76.27 183.84,76.27 183.84,74.88  173.85,74.88 "
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M191.32,74.67c-1.97,0-3.49,0.6-4.56,1.8c-1.07,1.2-1.61,2.89-1.61,5.07c0,2.2,0.54,3.9,1.6,5.11 c1.07,1.21,2.58,1.81,4.55,1.81c1.92,0,3.42-0.62,4.5-1.84c1.08-1.23,1.62-2.92,1.62-5.06c0-2.15-0.54-3.84-1.62-5.06 C194.73,75.28,193.23,74.67,191.32,74.67z M194.65,85.7c-0.75,0.94-1.87,1.4-3.35,1.4c-1.47,0-2.58-0.47-3.35-1.41 c-0.77-0.94-1.15-2.31-1.15-4.13c0-1.79,0.38-3.16,1.15-4.09c0.77-0.94,1.89-1.4,3.37-1.4c1.47,0,2.58,0.47,3.33,1.4 c0.75,0.93,1.13,2.3,1.13,4.1C195.78,83.38,195.4,84.76,194.65,85.7z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M142.89,83.14c-0.32,1.25-0.54,2.31-0.65,3.17c-0.2-1.19-0.45-2.26-0.74-3.21l-2.51-8.22h-1.64l-2.39,8.15 c-0.32,1.07-0.57,2.16-0.73,3.28c-0.13-0.94-0.35-1.99-0.64-3.15l-2.11-8.27h-1.64l3.55,13.4h1.53l2.61-8.92 c0.29-0.96,0.5-1.84,0.64-2.65c0.01,0.12,0.09,0.48,0.25,1.09c0.16,0.61,0.3,1.11,0.43,1.5l2.69,8.97h1.53l3.57-13.4h-1.64 L142.89,83.14z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M109.09,74.88h-3.46v13.4h1.55v-5.27h1.57c1.72,0,3.03-0.36,3.95-1.09c0.92-0.73,1.38-1.77,1.38-3.13 C114.09,76.18,112.43,74.88,109.09,74.88z M111.57,81c-0.61,0.44-1.61,0.67-2.98,0.67h-1.39v-5.45h1.73c1.22,0,2.12,0.22,2.7,0.65 c0.58,0.43,0.87,1.1,0.87,1.98C112.49,79.84,112.18,80.56,111.57,81z"
});

var _ref11 = /*#__PURE__*/React.createElement("rect", {
  x: 221.26,
  y: 3.68,
  className: "st1",
  width: 12.96,
  height: 61.47
});

var _ref12 = /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "287.37,54.39 262.56,54.39 262.56,3.68 249.61,3.68 249.61,65.15 287.37,65.15 "
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M264.17,82.71h2.78l3.23,5.57h1.83l-3.62-6.02c1.79-0.62,2.68-1.82,2.68-3.59c0-1.27-0.39-2.21-1.17-2.84 c-0.78-0.63-1.99-0.94-3.62-0.94h-3.66v13.4h1.55V82.71z M264.17,76.25h2.01c1.15,0,1.99,0.2,2.51,0.59 c0.52,0.39,0.78,1.03,0.78,1.91c0,0.87-0.26,1.53-0.77,1.97c-0.51,0.43-1.31,0.65-2.41,0.65h-2.13V76.25z"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M122.36,74.67c-1.97,0-3.49,0.6-4.56,1.8c-1.07,1.2-1.61,2.89-1.61,5.07c0,2.2,0.54,3.9,1.6,5.11 c1.07,1.21,2.58,1.81,4.55,1.81c1.92,0,3.42-0.62,4.5-1.84c1.08-1.23,1.62-2.92,1.62-5.06c0-2.15-0.54-3.84-1.62-5.06 C125.76,75.28,124.27,74.67,122.36,74.67z M125.68,85.7c-0.75,0.94-1.87,1.4-3.35,1.4c-1.47,0-2.58-0.47-3.35-1.41 c-0.77-0.94-1.15-2.31-1.15-4.13c0-1.79,0.38-3.16,1.15-4.09c0.77-0.94,1.89-1.4,3.37-1.4c1.47,0,2.58,0.47,3.33,1.4 c0.75,0.93,1.13,2.3,1.13,4.1C126.81,83.38,126.44,84.76,125.68,85.7z"
});

var _ref15 = /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "238.43,88.28 239.98,88.28 239.98,82.55 245.5,82.55 245.5,81.17 239.98,81.17 239.98,76.27  245.86,76.27 245.86,74.88 238.43,74.88 "
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M232.65,82.26c1.79-0.62,2.68-1.82,2.68-3.59c0-1.27-0.39-2.21-1.17-2.84c-0.78-0.63-1.99-0.94-3.62-0.94h-3.66 v13.4h1.55v-5.57h2.78l3.23,5.57h1.83L232.65,82.26z M230.56,81.37h-2.13v-5.12h2.01c1.15,0,1.99,0.2,2.51,0.59 c0.52,0.39,0.78,1.03,0.78,1.91c0,0.87-0.26,1.53-0.77,1.97C232.45,81.15,231.65,81.37,230.56,81.37z"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M253.54,74.67c-1.97,0-3.49,0.6-4.56,1.8c-1.07,1.2-1.61,2.89-1.61,5.07c0,2.2,0.54,3.9,1.6,5.11 c1.07,1.21,2.58,1.81,4.55,1.81c1.92,0,3.42-0.62,4.5-1.84c1.08-1.23,1.62-2.92,1.62-5.06c0-2.15-0.54-3.84-1.62-5.06 C256.95,75.28,255.46,74.67,253.54,74.67z M256.87,85.7c-0.75,0.94-1.87,1.4-3.35,1.4c-1.47,0-2.58-0.47-3.35-1.41 c-0.77-0.94-1.15-2.31-1.15-4.13c0-1.79,0.38-3.16,1.15-4.09c0.77-0.94,1.89-1.4,3.37-1.4c1.47,0,2.58,0.47,3.33,1.4 c0.75,0.93,1.13,2.3,1.13,4.1C258,83.38,257.62,84.76,256.87,85.7z"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M208.7,74.88h-3.46v13.4h1.55v-5.27h1.57c1.72,0,3.03-0.36,3.95-1.09c0.92-0.73,1.38-1.77,1.38-3.13 C213.7,76.18,212.04,74.88,208.7,74.88z M211.18,81c-0.61,0.44-1.61,0.67-2.98,0.67h-1.39v-5.45h1.73c1.22,0,2.12,0.22,2.7,0.65 c0.58,0.43,0.87,1.1,0.87,1.98C212.1,79.84,211.79,80.56,211.18,81z"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M191.9,3.43h-15.84l-21.58,61.72h13.97l4.42-14.64h22.29l4.42,14.64h13.97L191.9,3.43z M176.15,39.59 c4.34-14.16,6.98-23.03,7.89-26.62c0.23,1.02,0.6,2.38,1.11,4.12c0.51,1.74,2.83,9.24,6.92,22.5H176.15z"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M285.95,76.42c-0.08,1.16-0.13,2.24-0.13,3.22v8.63h1.55v-13.4h-2.32l-4.26,11.05h-0.07l-4.22-11.05h-2.34v13.4 h1.43v-8.52c0-1.3-0.04-2.41-0.13-3.35h0.07l4.52,11.88h1.25l4.56-11.86H285.95z"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M144.9,31.74c1.98-2.81,2.97-6.03,2.97-9.64c0-6.2-2-10.81-5.98-13.85c-3.98-3.04-10.13-4.56-18.44-4.56h-17.81 v61.47h12.96V41.56h6.91l14.59,23.59h14.39c-2.78-4.03-8.78-12.96-17.98-26.78C140.12,36.76,142.92,34.57,144.9,31.74z  M131.86,28.91c-1.96,1.36-4.98,2.05-9.08,2.05h-4.18v-16.6h3.94c4.18,0,7.26,0.62,9.26,1.85c1.98,1.23,2.98,3.3,2.98,6.21 C134.78,25.38,133.81,27.54,131.86,28.91z"
});

var _ref22 = /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "216.49,88.28 223.93,88.28 223.93,86.89 218.04,86.89 218.04,81.96 223.57,81.96 223.57,80.58  218.04,80.58 218.04,76.27 223.93,76.27 223.93,74.88 216.49,74.88 "
});

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    x: "0px",
    y: "0px",
    viewBox: "0 0 293 91",
    style: {
      enableBackground: "new 0 0 293 91"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.07ab9280.svg";
export { ForwardRef as ReactComponent };